import { layoutHierarchy } from 'components/OrganizationChart/hierarchy';

export const entityConfig = {
    organization: { label: 'Organization', table: 'm_org', prefix: 'org', color: '#60bdd5', codeLength: 8 },
    division: { label: 'Division', table: 'm_division', prefix: 'div', color: '#91b856', codeLength: 16 },
    department: { label: 'Department', table: 'm_department', prefix: 'dept', color: '#edbd27', codeLength: 16 },
    position: { label: 'Position', table: 'm_position', prefix: 'pos', color: '#cd6391', codeLength: 16 },
};

export function entityData(entityType, record) {
    const config = entityConfig[entityType];
    return {
        entityType,
        record,
        name: record[`${config.prefix}_name`],
        code: record[`${config.prefix}_code`],
        role: config.label,
        color: config.color,
    };
}

// Nullable dept_id means a position belongs directly to its division.
// Invalid references are reported rather than silently attaching rows to the wrong parent.
export function buildBackendChart(tables) {
    const nodes = [];
    const edges = [];
    const warnings = [];
    const byId = new Map();

    function add(entityType, record, parentId) {
        const config = entityConfig[entityType];
        const rawId = record[`${config.prefix}_id`];
        const nodeId = `${entityType}:${rawId}`;
        if (!rawId || !record[`${config.prefix}_name`] || byId.has(nodeId)) {
            warnings.push(`Invalid or duplicate ${config.label.toLowerCase()} row: ${rawId || 'missing ID'}.`);
            return;
        }
        if (entityType !== 'organization' && !byId.has(parentId)) {
            warnings.push(`Missing parent for ${record[`${config.prefix}_name`]}.`);
            return;
        }
        const node = { id: nodeId, type: 'member', position: { x: 0, y: 0 }, data: entityData(entityType, { ...record }) };
        nodes.push(node);
        byId.set(nodeId, node);
        if (parentId) edges.push({
            id: `${parentId}-${nodeId}`, source: parentId, target: nodeId,
            sourceHandle: 'bottom', targetHandle: 'top', type: 'smoothstep', selectable: false,
            pathOptions: { borderRadius: 0, offset: 16 }, style: { stroke: '#737373', strokeWidth: 1.5 },
        });
    }

    const rows = table => (tables[table] || []).filter(record => !record.deleted_date);
    rows('m_org').forEach(record => add('organization', record));
    rows('m_division').forEach(record => add('division', record, `organization:${record.org_id}`));
    rows('m_department').forEach(record => add('department', record, `division:${record.div_id}`));
    rows('m_position').forEach(record => {
        if (record.dept_id != null) {
            const department = byId.get(`department:${record.dept_id}`);
            if (department && department.data.record.div_id !== record.div_id) {
                warnings.push(`Division mismatch for ${record.pos_name}.`);
                return;
            }
        }
        add('position', record, record.dept_id == null ? `division:${record.div_id}` : `department:${record.dept_id}`);
    });

    return { nodes: layoutHierarchy(nodes, edges), edges, warnings };
}
